import { DeleteFloatingIpModalContent } from "@/admin/floating_ips/DeleteFloatingIpBlock.tsx";
import type { GQIpAddressItem } from "@/admin/floating_ips/FloatingIpsTable.tsx";
import {
    UnassignFloatingIpModalContent,
    type UnassignFloatingIpModalProps,
} from "@/admin/floating_ips/UnassignFloatingIpBlock.tsx";
import { WModalButton } from "@/components/button/WToolButton.tsx";
import { WModal } from "@/components/modal/WModal.tsx";
import { Toolbar } from "@/components/Toolbar.tsx";

export function FloatingToolbar({ item }: { item: GQIpAddressItem }) {
    const unassignItem: UnassignFloatingIpModalProps = {
        address: item.address,
        location: item._location ?? "",
    };
    return (
        <Toolbar>
            <WModal
                button={
                    <WModalButton
                        isDisabled={item.is_ipv6 || !item.assigned_to}
                        label="Unassign"
                        size="md"
                        icon="jp-wrong-icon"
                    />
                }
            >
                <UnassignFloatingIpModalContent {...unassignItem} />
            </WModal>

            <WModal button={<WModalButton isDisabled={item.is_ipv6} label="Delete" size="md" icon="jp-trash-icon" />}>
                <DeleteFloatingIpModalContent item={item} />
            </WModal>
        </Toolbar>
    );
}
